export default __webpack_public_path__ + "static/media/img3.c9e83cb9.png";